import { useEffect, useState } from "react";
import api from "@/lib/api";

// Build the AOG date set for the selected aircraft so the departure date
// picker can paint those days red. We pull active + scheduled AOGs and
// expand each [start_date, end_date] range into a Set of YYYY-MM-DD strings.
//
// Critical: parse YYYY-MM-DD as LOCAL midnight, not UTC. `new Date('2026-04-26')`
// is UTC midnight, which renders as Apr 25 in any negative-offset timezone
// (Americas), shifting every highlighted day one back from what the backend
// actually stored.
export default function useAogDates(aircraftId) {
  const [aogDateSet, setAogDateSet] = useState(null);

  useEffect(() => {
    if (!aircraftId) {
      setAogDateSet(null);
      return;
    }
    let cancelled = false;
    const parseLocal = (s) => {
      const [y, m, d] = (s || "").split("-").map(Number);
      if (!y || !m || !d) return null;
      return new Date(y, m - 1, d);
    };
    api
      .get(`/aog?aircraft_id=${aircraftId}`)
      .then((res) => {
        if (cancelled) return;
        const set = new Set();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        (res.data || []).forEach((ev) => {
          const start = parseLocal(ev.start_date);
          if (!start) return;
          const end = parseLocal(ev.end_date) || start;
          // Skip past AOGs — picker uses today onward.
          if (end < today) return;
          const cur = new Date(start);
          while (cur <= end) {
            const y = cur.getFullYear();
            const m = String(cur.getMonth() + 1).padStart(2, "0");
            const d = String(cur.getDate()).padStart(2, "0");
            set.add(`${y}-${m}-${d}`);
            cur.setDate(cur.getDate() + 1);
          }
        });
        setAogDateSet(set.size > 0 ? set : null);
      })
      .catch(() => {
        if (!cancelled) setAogDateSet(null);
      });
    return () => {
      cancelled = true;
    };
  }, [aircraftId]);

  return aogDateSet;
}
